import React from "react";
import "./DashboardExportDropdown.css";

const ExportIcon = () => (
  <svg
    className="export-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

const DashboardExportDropdown = ({
  onExcel,
  onPdf,
  onCsv,
  disabled = false,
  title = "Export",
}) => (
  <div
    className="cpd-export-wrap"
    onClick={(e) => e.stopPropagation()}
    onKeyDown={(e) => e.stopPropagation()}
  >
    <button
      type="button"
      className="export-button cpd-export-trigger"
      title={title}
      disabled={disabled}
    >
      <ExportIcon />
      <span>Export</span>
      <span className="cpd-export-caret">▾</span>
    </button>
    <ul className="cpd-export-menu" role="menu">
      <li>
        <button
          type="button"
          className="dropdown-item"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) onExcel?.();
          }}
        >
          Excel
        </button>
      </li>
      <li>
        <button
          type="button"
          className="dropdown-item"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) onPdf?.();
          }}
        >
          PDF
        </button>
      </li>
      <li>
        <button
          type="button"
          className="dropdown-item"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) onCsv?.();
          }}
        >
          CSV
        </button>
      </li>
    </ul>
  </div>
);

export default DashboardExportDropdown;
